<div class="browser-container">
  @if (error()) {
    <p
      class="error"
      part="browser-error"
      role="alert">
      {{ error() }}
    </p>
  }
  <div
    #layout
    class="browser"
    part="browser-shell"
    [class.resizing]="resizing()"
    [style.--archive-width]="tocWidth() + 'px'">
    <mbs-archive-toc
      exportparts="archive-panel, archive-heading, archive-title, archive-meta, archive-tree, archive-file, archive-file-size, archive-folder"
      [extensionMap]="extensionMap()"
      [hidden]="!archiveMode()"
      [maxArchiveBytes]="maxArchiveBytes()"
      [maxFileBytes]="maxFileBytes()"
      [maxPdfBytes]="maxPdfBytes()"
      [sizeUnits]="sizeUnits()"
      [timeoutMs]="timeoutMs()"
      [unknownFileBehavior]="unknownFileBehavior()"
      (entrySelected)="select($event)"
      (loaded)="archiveLoaded($event)"
      (loadError)="loadError.emit($event)"
      (overviewRequested)="showOverview()"
      (progressChange)="progressChange.emit($event)" />
    @if (archiveMode()) {
      <div
        aria-label="Resize archive panel"
        aria-orientation="vertical"
        aria-valuemin="160"
        class="splitter"
        part="browser-splitter"
        role="separator"
        tabindex="0"
        [attr.aria-valuemax]="maxTocWidth()"
        [attr.aria-valuenow]="tocWidth()"
        (keydown)="resizeKey($event)"
        (lostpointercapture)="stopResize()"
        (pointercancel)="stopResize()"
        (pointerdown)="startResize($event)"
        (pointermove)="resize($event)"
        (pointerup)="stopResize()"></div>
    }
    @if (overview()) {
      <section
        class="overview"
        part="browser-overview">
        <strong id="filename">{{ archiveName() }}</strong>
        <p>Select a supported file from Archive files to open its preview.</p>
      </section>
    }
    <mbs-document-viewer
      exportparts="viewer-button, viewer-sheet-tab, viewer-shell, viewer-toolbar, viewer-title, viewer-meta, viewer-controls, viewer-download, viewer-search, viewer-search-input, viewer-search-next, viewer-search-count, viewer-status, viewer-progress, viewer-progress-bar, viewer-viewport, viewer-empty, viewer-empty-title, viewer-empty-description, viewer-sheet-tabs, viewer-selection, viewer-document-frame, viewer-footer, viewer-text-controls, viewer-view-select, viewer-source, viewer-line-number, viewer-wrap, viewer-media-controls, viewer-media-surface, viewer-contents-toggle, viewer-contents, viewer-contents-splitter, viewer-contents-heading, viewer-contents-close, viewer-contents-expand, viewer-contents-link, viewer-dialog, viewer-dialog-title, viewer-dialog-description, viewer-dialog-select, viewer-dialog-options, viewer-dialog-option, viewer-dialog-actions, viewer-dialog-cancel, viewer-dialog-open"
      [contentsVisible]="contentsVisible()"
      [emptyStateTemplate]="emptyStateTemplate()"
      [maxExpandedBytes]="maxExpandedBytes()"
      [maxFileBytes]="maxFileBytes()"
      [maxPdfBytes]="maxPdfBytes()"
      [noticesUrl]="noticesUrl()"
      [pdfAssetsUrl]="pdfAssetsUrl()"
      [sizeUnits]="sizeUnits()"
      [style.display]="overview() ? 'none' : null"
      [timeoutMs]="timeoutMs()"
      [unknownFileBehavior]="unknownFileBehavior()"
      [view]="view()"
      [wordWrap]="wordWrap()"
      (contentsVisibleChange)="contentsVisibleChange.emit($event)"
      (formatSelected)="formatSelected.emit($event)"
      (loaded)="loaded.emit($event)"
      (loadError)="loadError.emit($event)"
      (progressChange)="progressChange.emit($event)"
      (viewChange)="viewChange.emit($event)"
      (wordWrapChange)="wordWrapChange.emit($event)" />
  </div>
</div>
